import { createContext } from "react";

export interface ActionContextValue {
  id: ID;
  version: string;
  datasetId: ID;
}

export const ActionContext = createContext<ActionContextValue>({
  datasetId: "",
  id: "",
  version: "",
});
